import SelectRegular from './components/SelectRegular';
import SelectForm from './components/SelectForm';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Select = forwardRef(
  (
    {
      store,
      hasOutline = false,
      hint = null,
      items,
      label,
      name,
      className = null,
      placeholder = 'Bitte auswählen',
      required = false,
      multiple = false,
    },
    ref,
  ) => {
    // This checks whether the return value of useFormStore() or
    // useSelectStore() has been passed. The useSubmit() and useValidate()
    // methods exist only on the form store.
    const isForm = !!(store.useSubmit && store.useValidate);
    const SelectBase = isForm ? SelectForm : SelectRegular;

    return (
      <SelectBase
        className={className}
        hasOutline={hasOutline}
        hint={hint}
        items={items}
        label={label}
        multiple={multiple}
        name={name}
        placeholder={placeholder}
        ref={ref}
        required={required}
        store={store}
      />
    );
  },
);

Select.propTypes = {
  className: PropTypes.string,
  hasOutline: PropTypes.bool,
  hint: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  label: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  /* eslint-disable react/forbid-prop-types */
  /** `useFormStore()` or `useSelectStore()` return value from `@ariakit/react` */
  store: PropTypes.object.isRequired,
};

Select.displayName = 'Select';

export default Select;
